// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3831":"4b345554","5839":"a8d72e23"}[chunkId] + ".chunk.css";
};